import React from "react";
import * as DateUtil from "@travellocal/utils/dateHelpers";
import { Link, Icon, Icomoon } from "../..";
import { MessageWithAvatar } from "./MessageWithAvatar";

import "./MessageWithAvatarAndReplyButton.scss";

export interface IMessageWithAvatarAndReplyButtonProps {
  avatarName?: string;
  avatarPlacement?: "left" | "right" | "bottom";
  avatarUrl?: string;
  children?: React.ReactNode;
  /**
   * Function to run when the `<LinkButton />` is clicked.
   */
  ctaCallback?: () => void;
  ctaUrl: string;
  sentTime: IDateTime;
}

/**
 * A message with an avatar, reply button and sent time. Wraps MessageWithAvatar.
 *
 * @status development
 */
export const MessageWithAvatarAndReplyButton: React.FC<IMessageWithAvatarAndReplyButtonProps> = (props) => {
  const { avatarName, avatarUrl, avatarPlacement, ctaUrl, children, sentTime, ctaCallback } = props;

  return (
    <div>
      <MessageWithAvatar
        avatarName={avatarName}
        avatarPlacement={avatarPlacement}
        avatarUrl={avatarUrl}
      >
        {children}

        <Link
          className="message__reply-button"
          to={ctaUrl}
          {...(ctaCallback && { onClick: ctaCallback })}
        >
          <Icon icomoon={Icomoon.undo2} /> Reply
        </Link>

        <span className="message__sent-time">
          <Icon icomoon={Icomoon.checkmark3} />
          <time>{DateUtil.formatDateTime(sentTime, "h:mma Do MMM YY")}</time>
        </span>
      </MessageWithAvatar>
    </div>
  );
}
